import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import Box from "../Box";

type ReviewButton = {
	icon: string;
	label: string;
	type: "positive" | "negative";
};

type Props = {
	body: string;
	buttons: ReviewButton[];
	appFont?: string;
	handleButtonsClick: (type: "positive" | "negative") => void;
};

const PromptButton = ({
	icon,
	label,
	appFont = "opensans",
	onPress,
}: {
	icon: string;
	label: string;
	appFont?: string;
	onPress: () => void;
}) => (
	<Pressable onPress={onPress}>
		<Box alignItems="center" padding={16} gap={8}>
			<Text variant="titleLarge">{icon}</Text>
			<Text
				variant="bodyMedium"
				style={{
					fontFamily: `${appFont}-semibold`,
				}}
			>
				{label}
			</Text>
		</Box>
	</Pressable>
);

const AppReviewForm = ({
	body,
	buttons,
	appFont,
	handleButtonsClick,
}: Props) => {
	return (
		<Box gap={16}>
			<Text
				style={{
					textAlign: "center",
				}}
				variant="bodyMedium"
			>
				{body}
			</Text>
			<Box flexDirection="row" justifyContent="center" alignItems="center">
				{buttons.map(({ icon, label, type }) => (
					<PromptButton
						key={type}
						icon={icon}
						label={label}
						appFont={appFont}
						onPress={() => handleButtonsClick(type)}
					/>
				))}
			</Box>
		</Box>
	);
};

export default AppReviewForm;
